import appointmentServiceReducer from 'features/appointment/services/reducers';
import authServiceReducer from 'features/auth/services/reducers';
import checkInServiceReducer from 'features/checkIn/services/reducers';
import customerServiceReducer from 'features/customer/services/reducers';
import cashierServiceReducer from 'features/cashier/services/reducers';
import paymentServiceReducer from 'features/payment/services/reducers';
import reportServiceReducer from 'features/report/services/reducers';
import settingServiceReducer from 'features/settingService/services/reducers';
import settingStaffReducer from 'features/settingStaff/services/reducers';
import ticketListServiceReducer from 'features/ticketList/services/reducers';
import turnServiceReducer from 'features/turn/services/reducers';
import userServiceReducer from 'features/user/services/reducers';
import uiServiceReducer from 'services/UI/reducer';
import shopServiceReducer from 'services/shop/reducers';
import multiplePaymentServiceReducer from 'features/payment/pages/PaymentPage/services/reducers';
import giftCardsReducer from 'features/giftCards/services/reducers';
import multiCardServiceReducer from 'features/payment/multipleCard/services/reducers';
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { createFilter } from 'redux-persist-transform-filter';
import { IAppointmentState } from 'features/appointment/services/types/reducer';

const appointmentFilter = createFilter(
  'appointment',
  ['availableStaffs']
);

const appointmentPersistConfig = {
  key: 'appointment',
  storage,
  whitelist: ['availableStaffs'],
  transforms: [appointmentFilter],
};
const appointment = persistReducer<IAppointmentState>(appointmentPersistConfig, appointmentServiceReducer);

const rootReducer = combineReducers({
  ui: uiServiceReducer,
  checkIn: checkInServiceReducer,
  user: userServiceReducer,
  cashier: cashierServiceReducer,
  payment: paymentServiceReducer,
  appointment,
  settingService: settingServiceReducer,
  settingStaff: settingStaffReducer,
  ticketList: ticketListServiceReducer,
  customer: customerServiceReducer,
  report: reportServiceReducer,
  auth: authServiceReducer,
  shop: shopServiceReducer,
  turn: turnServiceReducer,
  multiplePayment: multiplePaymentServiceReducer,
  giftCards: giftCardsReducer,
  multiCard: multiCardServiceReducer,
});

export default rootReducer;
